// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserServiceRequest } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_REQ_USER_SVC, SUC_REQ_USER_SVC } from '../../../../utils/strings';

export const useCreateUserServiceRequest = () => {
  const { submit } = useCreateSubmission(UserServiceRequest, SUC_REQ_USER_SVC, ERR_REQ_USER_SVC);
  return submit;
};
